let isPdfWorkerConfigured = false;

export const configurePdfWorker = (pdfjs) => {
  if (isPdfWorkerConfigured || !pdfjs?.GlobalWorkerOptions) {
    return;
  }

  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
    import.meta.url
  ).toString();

  isPdfWorkerConfigured = true;
};
